import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SectionSettings } from '../../store/reselectors/budget.data';
import { DropdownOption } from 'globals/store/programs.data';
import { CURRENCY_OPTIONS } from './../../store/reselectors/currencies.data';
import { hideTipSelector } from '../../store/reselectors/user.reselector';
import { Wrapper } from 'src/app/components/wrapper.component';
import { TipType } from 'globals/store/user.data';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { PercentBoxComponent } from './percent-box.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { CommonModule } from '@angular/common';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';

@Component({
    selector: 'budget-settings',
    templateUrl: './budget-settings.html',
    styleUrls: ['./budget-settings.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, PrettyNumbersPipe, FindByIdPipe, ToggleTabComponent, DropdownComponent, JoiInputComponent, ToggleTabComponent, PercentBoxComponent, TipTextComponent, CommonModule],
})

/* IMPORTANT!!! Even though this component uses wrapper, you should not use any wrapper stuff if it is in the share view.  It was easier to keep it this way than change to not doing that */
export class BudgetSettingsComponent extends Wrapper<BudgetSettingsComponent> implements OnInit{
  settings: SectionSettings
  currencyOptions = CURRENCY_OPTIONS
  maxHeight: string
  taxOptions: DropdownOption[] = [
    { id: 'inclusive', title: 'Tax inclusive' },
    { id: 'exclusive', title: 'Tax exclusive' },
  ]
  selectedTaxOption: DropdownOption
  hideFeesTip = true
  hideTaxTip = true
  hideDiscountTip = true
  hideMarkupTip = true
  hideUnitRateTip = true

  ngOnInit() {
    if (!this.data.isShareView) {
      this.selectProp(hideTipSelector, 'fees', 'hideFeesTip')
      this.selectProp(hideTipSelector, 'tax', 'hideTaxTip')
      this.selectProp(hideTipSelector, 'discount', 'hideDiscountTip')
      this.selectProp(hideTipSelector, 'markup', 'hideMarkupTip')
      this.selectProp(hideTipSelector, 'unitrate', 'hideUnitRateTip')
    }
    let { x, y, showMarkup } = this.data
    // console.log({ x, y })
    if (y && document.body.clientHeight - y < 400) {
      y = Math.max(1, document.body.clientHeight - 400);
    }
    console.log({ x, y })
    this.maxHeight = `${document.body.clientHeight - y - 50}px`
    // console.log({ x, y })
    if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
    if (showMarkup && !this.settings.markupRate) this.settings.markupRate = 0

    console.log({ y, clientHeight: document.body.clientHeight })
  }

  constructor(
    public dialogRef:MatDialogRef<BudgetSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BudgetSettingsDialogData,
  ) {
    super()
    this.settings = jsonCopyObject(data.settings)
    this.selectedTaxOption = data.settings.taxInclusive ? this.taxOptions[0] : this.taxOptions[1]
    dialogRef.backdropClick().subscribe(() => { this.close() })
  }

  hideTip(tip: TipType) {
    this.settingsService.hideTipType(tip)
  }

  close() {
    this.dialogRef.close(this.settings)
  }

  refreshSettingsRef() {
    this.settings = {...this.settings}
  }

  toggleUseCurrency() {
    this.settings.useCurrency = !this.settings.useCurrency
    if (!this.settings.useCurrency) {
      this.settings.currency = null
      this.settings.conversionRate = 1
    }
  }

  selectTaxOption(option: DropdownOption) {
    this.selectedTaxOption = option
    this.settings.taxInclusive = option.id === 'inclusive'
    this.refreshSettingsRef()
  }

  updateCurrency(currencyId: string) {
    this.settings.currency = currencyId
  }

  toggleMarkup() {
    this.settings.useMarkup = !this.settings.useMarkup
    if (this.settings.useMarkup) this.settings.useUnitRate = true
  }

  updateRate(key: keyof SectionSettings, rateString: string) {
    let rate: number
    try {
      rate = parseFloat(rateString) / 100
      if (isNaN(rate)) rate = 0
    } catch (error) {
      console.log(error)
      rate = 0
    }
    console.log({ rateString, rate })
    this.settings[key as string] = rate
    this.refreshSettingsRef()
  }



}

export interface BudgetSettingsDialogData {
  x: number
  y: number
  settings: SectionSettings
  budgetCurrency: string
  readOnly: boolean
  showFees?: boolean
  showMarkup?: boolean 
  showUnitRate?: boolean
  isShareView?: boolean

}


